import { useState, useEffect } from 'react'
import React from 'react'
import { getFavoriteCentersCount } from '@/domain/favoriteCenters/updateFavoriteStorage'

const IconHeartNav = ({
  onClick,
  className
}: {
  onClick: () => void
  className: string
}): JSX.Element => {
  const [favoriteCentersCount, setFavoriteCentersCount] = useState(
    getFavoriteCentersCount()
  )

  useEffect(() => {
    const updateCount = () => {
      setFavoriteCentersCount(getFavoriteCentersCount())
    }

    window.addEventListener('favoritesUpdated', updateCount)

    return () => {
      window.removeEventListener('favoritesUpdated', updateCount)
    }
  }, [])

  return (
    <div
      className={`-mr-[8px] box-border flex aspect-square shrink-0 cursor-pointer items-center justify-center p-[12px] md:-mr-[2px] ${className}`}
      onClick={onClick}
    >
      {favoriteCentersCount > 0 && (
        <div className="absolute right-[80px] top-4 inline-flex h-4 min-w-4 flex-col items-center justify-center rounded-[100px] bg-primary-100 px-1 md:right-1 md:top-2">
          <div className="font-Figtree justify-center text-xs font-medium leading-none text-primary-800">
            {favoriteCentersCount}
          </div>
        </div>
      )}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 18 17"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9 2.314C13.4384 -2.24799 24.5343 5.7355 9 16C-6.53427 5.7355 4.56164 -2.24799 9 2.314Z"
          stroke="#162941"
          strokeWidth="1.5"
        />
      </svg>
    </div>
  )
}

export default IconHeartNav
